import type { ReactNode } from "react";

type U2000CommonFormHeaderActionsProps = {
  actionsButtons: ReactNode;
};

function U2000CommonFormHeaderActions({ actionsButtons }: U2000CommonFormHeaderActionsProps) {
  return (
    <div className="flex flex-wrap items-center gap-3" role="toolbar" aria-label="Actions du formulaire">
      {actionsButtons}
    </div>
  );
}

export default U2000CommonFormHeaderActions;
